import React, { useEffect, useRef } from 'react';
import { Formik, Form } from "formik";
import { Button, Container, Row, Col } from "reactstrap";
import { EditProvider } from '../../Services/EditContext';

const SubmitFormWrapper = ({ edit, children, handleSubmit, isSubmitting, setHandleSubmit, setSubmitting }) => {
    const haveSet = useRef(false);


    if (!haveSet.current && setHandleSubmit) {
        haveSet.current = true;
        setHandleSubmit(handleSubmit);
    }

    useEffect(() => {
        setSubmitting && setSubmitting(isSubmitting);
    }, [isSubmitting, setSubmitting])
    return <EditProvider edit={edit}>
        <Form>
            <React.Fragment>
                {children}
                {edit && !setHandleSubmit ? <Container><Row><Col><Button type='submit' disabled={isSubmitting}>Submit</Button></Col></Row></Container> : null}
            </React.Fragment>
        </Form>
    </EditProvider>
}
const FormContainer = ({ initialValues, validationSchema, edit, setHandleSubmit, onSubmit, children, setSubmitting }) => {
    return (<Formik initialValues={{ ...initialValues }}
        onSubmit={onSubmit}

        enableReinitialize={true}
        validateOnMount={true}
        validationSchema={validationSchema}>
        {(props) => {
            return <SubmitFormWrapper {...props} edit={edit} children={children} setHandleSubmit={setHandleSubmit} setSubmitting={setSubmitting} />
        }}</Formik>)
};

export default FormContainer;